import React, { useEffect, useState } from "react";
import { translate } from '../../../utils/language';
import { CloseButton } from '../../../assets/svgs'
import MyInput from '../../../components/ui/MyInput';
import PrimaryButton from '../../../components/ui/PrimaryButton';
import CreateAction from "../../../components/operational/createAction";

function ThemesModalNameChanger({ isOpen, setIsOpen, getThemes, theme }) {

  const [error, setError] = useState(false)

  const [themeName, setThemeName] = useState("");

  useEffect(() => {
    setThemeName(theme?.name)
  }, [theme])
  const handleClickedSaveButton = async () => {
    if (themeName == "") {
      setError(true)
      return
    }
    setError(false)
    const response = await CreateAction({
      method: "patch",
      path: `/mainThemes/${theme.id}`,
      showPreLoader: true,
      isFileUploading: false,
      data: {
        "name": themeName
      }

    });
    setIsOpen(false);
    setThemeName("")
    getThemes()
  }

  return (
    <>
      {isOpen && <div class="appear fixed inset-0 overflow-y-auto flex flex-col p-5 items-center overflow-hidden top-0 left-0 z-[50] justify-center">
        <div className='shadow' ></div>
        <div className="z-[500] bg-white p-8 h-[400px] w-[600px]  overflow-auto h-auto scrollbar-y-visible">
          <div className='flex flex-row flex-between w-full z-[500] items-center py-4'>
            {/* <div>{translate("editView")}</div> */}
            <div className='w-[250px] shrink-0'>Tema Adını Değiştir</div>
            <div className='ml-auto cursor-pointer' onClick={() => setIsOpen(false)}>
              <CloseButton className={"fill-[#60646F]"}></CloseButton>
            </div>
          </div>
          <div className="flex flex-row gap-[30px]">
            <div className='flex flex-col w-full  shrink-0'>
              <MyInput placeholder="Tema adı giriniz." isError={error} isErrorMessage={"Tema adını giriniz."} labelViaPlaceholder={false} type="text" color="black" onChange={(e) => setThemeName(e)} label="" value={themeName} />
              <PrimaryButton
                onClick={() => { handleClickedSaveButton() }}
                value="Kaydet"
                classes={"w-full mt-4 !h-[50px]"}
              />
            </div>
          </div>
        </div>
      </div >}
    </>
  )
}

export default ThemesModalNameChanger